import React, { useCallback, useState } from 'react';
import { UseFormReset } from 'react-hook-form';

import {
  ButtonColor,
  ButtonStyle,
  ButtonType,
} from 'components/Button/constants';
import Button from 'components/Button';
import { defaultValues, Model, schema } from './model';
import Fieldset from 'components/Fieldset';
import Form from 'components/Form';
import logger from 'modules/logger';
import { ModalInfoTemplate } from 'modules/modals/constants';
import { QuestionSize } from 'components/Questions/constants';
import { QuestionText } from 'components/Questions';
import { useModalInfo } from 'modules/modals/hooks';

const QuestionsInputs: React.FunctionComponent = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { showModalInfo } = useModalInfo();

  const handleSubmit = useCallback(
    async (data: Model, reset: UseFormReset<Model>) => {
      logger.debug('Submit:', data);
      setIsSubmitting(true);
      setTimeout(
        () =>
          !!showModalInfo &&
          showModalInfo({
            onClose: () => {
              setIsSubmitting(false);
              reset();
            },
            template: ModalInfoTemplate.DEBUG_SUCCESSFUL_SUBMISSION,
          }),
        2000,
      );
    },
    [showModalInfo],
  );

  return (
    <Form<Model>
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      schema={schema}>
      {({ control, isFormSubmitting }) => (
        <React.Fragment>
          <Fieldset title="Inputs">
            <QuestionText
              control={control}
              label="Label"
              name="debugTextInput"
              placeholder="Placeholder"
              readOnly={isSubmitting}
            />
            <QuestionText
              control={control}
              label="Label"
              name="debugTextInput"
              placeholder="Placeholder"
              size={QuestionSize.SMALL}
              readOnly={isSubmitting}
            />
            <QuestionText
              control={control}
              label="Label"
              name="debugTextInputEmpty"
              placeholder="Placeholder"
              readOnly={isSubmitting}
            />
            <QuestionText
              control={control}
              label="Label"
              name="debugTextInputEmpty"
              placeholder="Placeholder"
              size={QuestionSize.SMALL}
              readOnly={isSubmitting}
            />
          </Fieldset>

          <Button
            color={ButtonColor.BLUE}
            label="Submit"
            loading={isFormSubmitting || isSubmitting || !showModalInfo}
            style={ButtonStyle.PRIMARY}
            type={ButtonType.SUBMIT}
          />

          <Fieldset title="Inputs - Disabled">
            <QuestionText
              control={control}
              disabled={true}
              label="Label"
              placeholder="Placeholder"
              name="debugTextInputDisabled"
              readOnly={isSubmitting}
            />
            <QuestionText
              control={control}
              disabled={true}
              label="Label"
              name="debugTextInputDisabled"
              placeholder="Placeholder"
              size={QuestionSize.SMALL}
              readOnly={isSubmitting}
            />
            <QuestionText
              control={control}
              disabled={true}
              label="Label"
              placeholder="Placeholder"
              name="debugTextInputDisabledEmpty"
              readOnly={isSubmitting}
            />
            <QuestionText
              control={control}
              disabled={true}
              label="Label"
              name="debugTextInputDisabledEmpty"
              placeholder="Placeholder"
              size={QuestionSize.SMALL}
              readOnly={isSubmitting}
            />
          </Fieldset>
          <Fieldset title="Inputs - Read Only">
            <QuestionText
              control={control}
              label="Label"
              name="debugTextInputReadOnly"
              placeholder="Placeholder"
              readOnly={true}
            />
            <QuestionText
              control={control}
              label="Label"
              name="debugTextInputReadOnly"
              placeholder="Placeholder"
              readOnly={true}
              size={QuestionSize.SMALL}
            />
            <QuestionText
              control={control}
              label="Label"
              name="debugTextInputEmptyReadOnly"
              placeholder="Placeholder"
              readOnly={true}
            />
            <QuestionText
              control={control}
              label="Label"
              name="debugTextInputEmptyReadOnly"
              placeholder="Placeholder"
              readOnly={true}
              size={QuestionSize.SMALL}
            />
          </Fieldset>
        </React.Fragment>
      )}
    </Form>
  );
};

export default React.memo(QuestionsInputs);
